import {
  createEthereumPlugin,
  createSiweMessage
} from "./chunk-CS23VDDD.mjs";
import "./chunk-WUKYLWAZ.mjs";
import "./chunk-GV6AIHPN.mjs";

// src/extension/isInstalled.ts
function isInstalled() {
  try {
    const phantom = window?.phantom;
    return !!phantom;
  } catch (error) {
    return false;
  }
}

// src/extension/plugin.ts
var extension = {
  isInstalled
};
function createExtensionPlugin() {
  return {
    name: "extension",
    create: () => extension
  };
}

// src/index.ts
function createPhantom({ plugins = [] }) {
  const phantom = {};
  for (const plugin of plugins) {
    phantom[plugin.name] = plugin.create();
  }
  return phantom;
}
export {
  createEthereumPlugin,
  createExtensionPlugin,
  createPhantom,
  createSiweMessage,
  isInstalled as isPhantomExtensionInstalled
};
